export const styles = theme => ({
  tooltip: {
    background: theme.palette.common.black,
    boxShadow: theme.shadows[1],
    fontSize: theme.typography.fontSize,
  }
})



// WEBPACK FOOTER //
// ./src/components/Tooltip/styles.js